export const FEE_PAYMENT_STATUS = {
  PAID: 'PAID',
  PENDING: 'PENDING',
  NEW: 'NEW',
  OVERDUE: 'OVERDUE',
  ENDED: 'ENDED'
} as const;

export type FeePaymentStatus = typeof FEE_PAYMENT_STATUS[keyof typeof FEE_PAYMENT_STATUS];

export const FEE_PAYMENT_STATUS_ICON: Record<FeePaymentStatus, string> = {
  [FEE_PAYMENT_STATUS.PAID]: 'check_circle',
  [FEE_PAYMENT_STATUS.OVERDUE]: 'error',
  [FEE_PAYMENT_STATUS.ENDED]: 'block',
  [FEE_PAYMENT_STATUS.NEW]: 'fiber_manual_record',
  [FEE_PAYMENT_STATUS.PENDING]: 'fiber_manual_record'
};

export const FEE_PAYMENT_STATUS_LABEL: Record<FeePaymentStatus, string> = {
  [FEE_PAYMENT_STATUS.PAID]: 'Completed',
  [FEE_PAYMENT_STATUS.PENDING]: 'Pending',
  [FEE_PAYMENT_STATUS.NEW]: 'Pending',
  [FEE_PAYMENT_STATUS.OVERDUE]: 'Overdue',
  [FEE_PAYMENT_STATUS.ENDED]: 'Ended'
};

export const FEE_PAYMENT_STATUS_LABEL_KEY: Record<FeePaymentStatus, string> = {
  [FEE_PAYMENT_STATUS.PAID]: 'fee.status.completed',
  [FEE_PAYMENT_STATUS.PENDING]: 'fee.status.pending',
  [FEE_PAYMENT_STATUS.NEW]: 'fee.status.pending',
  [FEE_PAYMENT_STATUS.OVERDUE]: 'fee.status.overdue',
  [FEE_PAYMENT_STATUS.ENDED]: 'fee.status.ended'
};

export const FEE_PAYMENT_STATUS_DEFAULT_ICON = 'help_outline';
